<template>
<div>
<v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on:dialog}">
        <v-tooltip bottom
      :nudge-top="tooltip.nudgeTop"
      :nudge-right="tooltip.nudgeRight"
      :open-on-focus="focus"
      >
      <template v-slot:activator="{on:tooltip}">
        <v-btn

              icon

              v-on="{...tooltip, ...dialog}"

            >
            <v-icon large>
              mdi-folder-upload
            </v-icon>


        </v-btn>
        </template>
        <span>Upload new collection</span>
        </v-tooltip>

      </template>

  <v-card>
    <v-card-title>
      Upload a spreadsheet of securities
      <v-spacer />
    </v-card-title>
    <v-card-text>
      <uploader :hide="true" destination="collections" @success="showSuccessMessage" />
              Upload a list of MBS CUSIPs in bulk using the simple template below
              <ul>
                <li>The "cusip" column is mandatory. The optional "amount" is currently un-used in the output files, but is carried through to the output, and may be used for future group-level summaries. </li>
                <li>After upload, the output generation is automatically started</li>
                <li><code>.xlsx</code> and <code>.csv</code> files supported</li>

              </ul>
    </v-card-text>
    <v-card-actions class="pb-5" >
      <v-btn outlined color="info" href="lvl11_cusip_upload_template.xlsx"
      >
      Download template</v-btn>
    </v-card-actions>

  </v-card>
  </v-dialog>

     </div>
</template>
<script>
import { mapState } from 'vuex'
import Uploader from '@/components/Uploader.vue'
export default {
  data(){
    return {
      dialog:false,
      focus:false,
      success: false
      }
  },
  components: {
    'uploader': Uploader
  },
  computed: {
    ...mapState({
      user: 'user',
      tooltip: 'tooltip'
    })
  },
  methods: {
    showSuccessMessage(){
        this.dialog = false;
        this.success = true;
  }
  }

}
</script>
